module.exports = __webpack_public_path__ + "media/images/logo-3ca9baa0.png";